import Footer from './Footer'
import Navbar from './ui/navbar/navbar'

interface AppShellProps {
  children?: React.ReactNode
}

export default function AppShell({ children }: AppShellProps) {
  return (
    <div className="bg-shire-light flex min-h-screen flex-col">
      <Navbar />

      <main className="grow">{children}</main>

      <Footer />
    </div>
  )
}
